import React from 'react'
import FloatingButtonIcon from './FloatingButtonIcon'
const FloatingContactButton = ({ targetId }) => {
  const scrollToSection = () => {
    const element = document.getElementById(targetId)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <button className="floating-button" onClick={scrollToSection}>
      <FloatingButtonIcon className="material-icons" />
    </button>
  )
}

export default FloatingContactButton
